export default class ScrollingHandler {
  static prepareOnClick(href, wrappedCallback = () => {}) {
    // Prepare the callback function for smooth scrolling.
    // this will be a wrapper in the callback already set for each
    // particular link.
    return e => {
      // In case document exists, and there is a hash in URL,
      // then we probably want to apply smooth scrolling for an element in page.
      // Note that this will be applied ONLY to React-based links,
      // where routing is applied.
      if (href) {
        if (href.includes('#')) {
          const hash = href.split('#')[1];
          const element = document.body.querySelector(`#${hash}`);

          // Hash scrolling is ignored in case the element is not found.
          // Such cases exist when we have link navigation to another page that the URL
          // contains a hash.
          if (element) {
            e.preventDefault();
            element.scrollIntoView({behavior: 'smooth'});

            // Set the state to the URL bar, since we have applied preventDefault action,
            // therefore it is not updated.
            window.history.pushState(null, null, href);
          }

          // Check if url contains a key parameter and click tab panel to open
          if (href !== '') {
            const url = new URL(href, window.location.origin);

            if (url.searchParams.get('key')) {
              const keyElement = document.body.querySelector(`#${ url.searchParams.get('key')}`);
  
              if (keyElement) {
                keyElement.click();
              }
            }
          }
          // Else, if no # is specified, we must check if the link
          // is the base link of our page, therefore leading to page top scrolling.
          // Notice we ommit query parameters for the check.
          // Also, we remove trailing slash from both of the links.
        } else {
          const hrefQueryArray = href.split('?');
          if (
            hrefQueryArray[0] &&
            window.location.pathname &&
            hrefQueryArray[0].replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '')
          ) {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth'
            });

            window.history.pushState(null, null, href);
          }
        }
      }

      return wrappedCallback(e);
    };
  }
}
